import React from 'react';
import { useReduxState } from 'hooks';
import { getFormattedDate } from 'lib/common';

interface Props {
  date: Date | number | string;
  dateFormat?: string;
  dateFormatOptions?: Parameters<typeof getFormattedDate>[0]['options'];
  inputDateFormat?: string;
  wrappedInDiv?: boolean;
  withTime?: boolean;
  withTimeStyles?: React.CSSProperties;
}

const DisplayFormattedDate = ({
  date,
  dateFormat = 'dd.MM.y',
  dateFormatOptions = {},
  inputDateFormat,
  wrappedInDiv = false,
  withTime = false,
  withTimeStyles = {}
}: Props) => {
  const { theme } = useReduxState();
  const Wrapper = wrappedInDiv ? 'div' : React.Fragment;

  const formattedDate = getFormattedDate({
    date,
    dateFormat,
    inputDateFormat,
    options: dateFormatOptions
  });

  const formattedTime = withTime
    ? getFormattedDate({
        date,
        dateFormat: 'HH:mm',
        inputDateFormat
      })
    : null;

  return (
    <Wrapper>
      {formattedDate || null}
      {withTime && formattedTime ? (
        <span
          style={{
            color: theme.textColorLighter,
            marginLeft: '5px',
            ...withTimeStyles
          }}
        >
          {formattedTime}
        </span>
      ) : null}
    </Wrapper>
  );
};

export default DisplayFormattedDate;
